import React from "react";

import { higlightFn } from "./HighlightFn";

interface HighlightProps {
  content: string | undefined;
  highlight: string | undefined;
}

export const Highlight: React.FC<HighlightProps> = ({ content, highlight }) => {
  if (!content) return null;
  if (!highlight) {
    return <span>{content}</span>;
  }

  const highlighted = higlightFn(content, highlight);
  return <span dangerouslySetInnerHTML={{ __html: highlighted }} />;
};
